/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { Text } from '@az/starc-ui';
import styles from './styles.module.scss';
import { useLabels } from '@/hooks/useLabels';
import { useModalOPPromptContext } from '@/components/ModalOPPromptContext';

const labelMap = {
  expiresIn: 'label_expires_in',
};

export const ExpirationDate = () => {
  const labels = useLabels(labelMap);
  const { offer } = useModalOPPromptContext();

  if (!offer?.expirationDate) {
    return null;
  }

  return (
    <Text variant="subtitle-regular" className={styles.promoExpireDate}>
      {labels.expiresIn} {offer.expirationDate}.
    </Text>
  );
};
